import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ContentPageState {
  url: string;
}

export const initialState: ContentPageState = {
  url: '',
};

const contentPageSlice = createSlice({
  name: 'contentPage',
  initialState,
  reducers: {
    setContentPageUrl(state, action: PayloadAction<string>) {
      return {
        url: action.payload,
      };
    },
    resetContentPageUrl() {
      return {
        url: '',
      };
    },
  },
});

export const contentPageUrlSelector = ({ contentPage }: { contentPage: ContentPageState }) => contentPage.url;

export const { setContentPageUrl, resetContentPageUrl } = contentPageSlice.actions;

export default contentPageSlice.reducer;
